export const LEGACY_ONLINE_CONTACT_DETAILS_KEY = "user";
export class LegacyOnlineContactDetailsStorageManager {
    store(_) {
        throw new Error("Method not implemented.");
    }
    restore() {
        const legacyContactDetailsDataString = localStorage.getItem(LEGACY_ONLINE_CONTACT_DETAILS_KEY);
        if (legacyContactDetailsDataString === null) {
            return null;
        }
        const legacyContactDetailsData = JSON.parse(legacyContactDetailsDataString);
        try {
            return {
                type: "Online",
                fullName: legacyContactDetailsData.fullName,
                email: legacyContactDetailsData.email,
                phoneNumber: legacyContactDetailsData.parsedPhone,
                phoneCountry: null,
            };
        }
        catch (_) {
            return null;
        }
    }
    erase() {
        throw new Error("Method not implemented.");
    }
}
